import axiosGraphQL from './GraphQL/axiosGraphQL';
const productType = {
  getAllProductType: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetProductTypeComboBox($input:TcodeWhereInput!){
    getCode(where:$input){
        items{
            id
            name
        }
    }
}`,
      variables: {
        input: {
          groupId: { equals: '102' },
        },
      },
    });
  },
};

export default productType;
